export default __webpack_public_path__ + "static/portrait-a7f95d3948f093ffa2aa2e17ffbcccb0.jpg";